import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TFormType {
  code: string;
  name: string;
  status: string;
  previousFormVersionCode: string;
  tag: string;
}

export interface IFormType extends TFormType {}

const FormType = Model(
  (model: TFormType): IFormType => {
    const _formType: TFormType = Object.assign({}, model);

    let create = (formType: IFormType): IFormType => {
      let obj = ValidatableObject(formType);
      return obj;
    };

    let formType = {
      get code() {
        return _formType.code;
      },
      set code(value) {
        _formType.code = value;
      },
      get name() {
        return _formType.name;
      },
      set name(value) {
        _formType.name = value;
      },
      get status() {
        return _formType.status;
      },
      set status(value) {
        _formType.status = value;
      },
      get previousFormVersionCode() {
        return _formType.previousFormVersionCode;
      },
      set previousFormVersionCode(value) {
        _formType.previousFormVersionCode = value;
      },
      get tag() {
        return _formType.tag;
      },
      set tag(value) {
        _formType.tag = value;
      }
    };

    return create(formType);
  }
);

export default FormType;
